export var BankName = "Barclays";
export var BankAccountNumber = "93310825";
export var BankSortCode = "20-36-08";
export default { BankName: BankName, BankAccountNumber: BankAccountNumber, BankSortCode: BankSortCode };
